import gql from "graphql-tag";

export const RUN_EXTRACTORS = gql`
	mutation RunExtractors(
		$input: RunExtractorsInput!
	) {
		runExtractors(input: $input) {
			boolean
		}
	}
`;
